import { ConfigProvider, Skeleton, Space, theme, Tooltip, Typography } from 'antd';
import { meta } from '../build-meta';
import useApiVersion from '../hooks/useApiVersion';
import { MAIN_SIDEBAR_WIDTH } from '../styles/theme';

const isDevelopmentMode: () => boolean = () => !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export default function VersionInfo({ loadingLayout = false }: { loadingLayout?: boolean }) {
    const {
        token: { colorTextSecondary, fontSizeSM, marginSM, paddingXXS }
    } = theme.useToken();

    const buildInfo = `UI Version: ${meta.version}\nUI Commit ID: ${meta.commitId}\nUI Build Date: ${meta.buildDate}`;
    const { data, isLoading } = useApiVersion();
    const apiVersion = data?.data?.split('\n')[0];
    const apiCommitID = data?.data?.split('\n')[1];
    const apiversionInfo = `API Version: ${apiVersion}\nAPI Commit ID: ${apiCommitID}`;
    //TODO: api version not available text comes with status code 200, is this a more proper way if it comes with error code
    const apiVersionText = apiVersion === 'GRISPI VERSION NOT AVAILABLE' ? '' : 'v' + apiVersion;

    if (isLoading)
        return (
            <Space
                direction="vertical"
                style={{
                    position: 'absolute',
                    bottom: marginSM,
                    width: MAIN_SIDEBAR_WIDTH,
                    padding: paddingXXS
                }}
            >
                <Skeleton.Button active size="small" />
                <Skeleton.Button active size="small" />
            </Space>
        );

    return (
        <ConfigProvider
            theme={{
                inherit: false
            }}
        >
            <div
                build-info={buildInfo}
                api-build-info={apiversionInfo}
                style={{
                    position: 'absolute',
                    bottom: marginSM,
                    cursor: 'pointer',
                    width: MAIN_SIDEBAR_WIDTH,
                    padding: paddingXXS
                }}
            >
                <Tooltip
                    overlayStyle={{ whiteSpace: 'pre-line' }}
                    overlayInnerStyle={{ width: 'fit-content' }}
                    placement="right"
                    title={isDevelopmentMode() ? buildInfo + '\n' + apiversionInfo : 'Grispi Version'}
                    trigger={loadingLayout ? [] : ['hover']}
                >
                    <Space align="center" className="full-width" direction="vertical">
                        <Typography.Text
                            ellipsis
                            style={{
                                color: colorTextSecondary,
                                fontSize: fontSizeSM,
                                maxWidth: MAIN_SIDEBAR_WIDTH - 2 * paddingXXS
                            }}
                        >
                            v{meta.version}
                        </Typography.Text>
                        {apiVersionText && (
                            <Typography.Text ellipsis style={{ color: colorTextSecondary }}>
                                {apiVersionText}
                            </Typography.Text>
                        )}
                    </Space>
                </Tooltip>
            </div>
        </ConfigProvider>
    );
}
